module.exports = __webpack_public_path__ + "media/images/large-card-nav-divider-90afd4ea.png";